import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";

@Component({
    selector: "pin-filter",
    templateUrl: "./pin-filter.component.html",
    imports: [CommonModule, BsDropdownModule],
    styleUrls: ["./pin-filter.component.css"]
})
export class PinFilterComponent {
  @Input() showUnpinnedOption: boolean = true;

  currentFilter: string = "all";
  @Output() filterChanged: EventEmitter<string> = new EventEmitter();

  changeFilter(filter: string) {
    this.currentFilter = filter;
    this.filterChanged.emit(filter);
  }
}
